module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-700.224e90ec.ttf";